import React from 'react';

import {
  CheckboxContainer,
  StyledCheckbox,
  PrivacyLink,
  CheckboxLabel,
} from '../../styled/privacy-policy';

const PrivacyCheckbox = ({ checked, onChange }) => {
  const handleChange = (e) => {
    onChange && onChange(e.target.checked);
  };
  return (
    <CheckboxContainer>
      <StyledCheckbox
        type="checkbox"
        id="privacyPolicy"
        checked={checked}
        onChange={handleChange}
      />
      <CheckboxLabel htmlFor="privacyPolicy">
        He leído y acepto la{' '}
        <PrivacyLink
          rel="noopener noreferrer"
          aria-label="Abrir política de privacidad en una nueva ventana"
          href="https://plus.badi.com/privacy-policy/"
          target="_blank"
        >
          política de privacidad
        </PrivacyLink>
      </CheckboxLabel>
    </CheckboxContainer>
  );
};

export default PrivacyCheckbox;
